// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.health-state-indicator-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 32px;
  margin: 32px 0 16px 0;
}

.health-state-meter {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 140px;
  margin-left: auto;
}

.health-state-label {
  margin-bottom: 8px;
  text-align: left;
  align-self: flex-start;
}

.health-state-bars {
  display: flex;
  gap: 8px;
}

.health-state-bar {
  width: 80px;
  height: 4px;
  border-radius: 3px;
  transition: background 0.3s;
  background: #E0E0E0;
}

.health-state-warning-row {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: 4px;
  min-width: 300px;
}

.health-state-warning-icon {
  display: flex;
  align-items: center;
}

.health-state-warning-message {
  background: #BDBDBD;
  color: #212121;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  min-width: 180px;
  max-width: 260px;
  word-break: break-word;
  white-space: pre-line;
}`, "",{"version":3,"sources":["webpack://./src/pages/HealthStateIndicator/components/HealthStateIndicator.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;AACF","sourcesContent":[".health-state-indicator-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 32px;\n  margin: 32px 0 16px 0;\n}\n\n.health-state-meter {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 140px;\n  margin-left: auto;\n}\n\n.health-state-label {\n  margin-bottom: 8px;\n  text-align: left;\n  align-self: flex-start;\n}\n\n.health-state-bars {\n  display: flex;\n  gap: 8px;\n}\n\n.health-state-bar {\n  width: 80px;\n  height: 4px;\n  border-radius: 3px;\n  transition: background 0.3s;\n  background: #E0E0E0; // fallback\n}\n\n.health-state-warning-row {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-left: 4px;\n  min-width: 300px;\n}\n\n.health-state-warning-icon {\n  display: flex;\n  align-items: center;\n}\n\n.health-state-warning-message {\n  background: #BDBDBD;\n  color: #212121;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 14px;\n  min-width: 180px;\n  max-width: 260px;\n  word-break: break-word;\n  white-space: pre-line;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
